export const formatDate = (value: string) => new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC', day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(`${value}T12:00:00Z`))

export const formatMoney = (value: number, currency: string) => {
  if (currency === 'USD') return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(value)
  if (currency === 'BRL milhões') return `R$ ${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(value)} milhões`
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(value)
}

export const statusLabels: Record<string, string> = {
  'documentado': 'Documentado', 'confirmado-pelo-citado': 'Confirmado pelo citado', 'em-investigacao': 'Em investigação',
  'denunciado': 'Denunciado', 'acusacao-contestada': 'Acusação contestada', 'decisao-processual': 'Decisão processual',
  'provas-anuladas': 'Provas anuladas', 'arquivado-ou-rejeitado': 'Arquivado ou rejeitado',
  'condenacao-nao-definitiva': 'Condenação não definitiva', 'condenacao-definitiva': 'Condenação definitiva',
  'sem-comprovacao-suficiente': 'Sem comprovação suficiente', 'informacao-falsa-ou-imprecisa': 'Informação falsa ou imprecisa',
}
